"use strict";

exports.__esModule = true;
exports.TicketDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _Translator = require("../../Core/Translator");
var _TicketDetailsViewMode = require("./TicketDetailsViewMode");
var _TicketDetailsEditMode = require("./TicketDetailsEditMode");
var _useTicketDetailsController = require("./useTicketDetailsController");
var _AppNavbar = require("../../App/AppNavbar");
var _DetailsComponent = require("../../Core/DetailsComponent");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TicketDetails = exports.TicketDetails = (0, _reactRouterCompat.withRouter)(function TicketDetailsWithRouterProp(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var width = props.width,
    height = props.height,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
  var _useTicketDetailsCont = (0, _useTicketDetailsController.useTicketDetailsController)(props),
    isLoading = _useTicketDetailsCont.isLoading,
    data = _useTicketDetailsCont.data,
    error = _useTicketDetailsCont.error,
    handleUpdateTicket = _useTicketDetailsCont.handleUpdateTicket,
    handleAssigneeClick = _useTicketDetailsCont.handleAssigneeClick,
    handleCreateComment = _useTicketDetailsCont.handleCreateComment,
    handleEditTicketComment = _useTicketDetailsCont.handleEditTicketComment,
    handleDeleteTicketComment = _useTicketDetailsCont.handleDeleteTicketComment,
    handleClose = _useTicketDetailsCont.handleClose,
    handleAssignToUser = _useTicketDetailsCont.handleAssignToUser,
    refreshTicketData = _useTicketDetailsCont.refreshTicketData,
    editMode = _useTicketDetailsCont.editMode,
    setEditMode = _useTicketDetailsCont.setEditMode;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
  }
  var ticketDetails = data[0];
  var ticketTypesResponse = data[1];
  if (error || !ticketDetails || !ticketTypesResponse) {
    var fetchError = error || new Error("Ticket Not Found");
    return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: fetchError,
      title: translate("TicketDetails.fetchError", "Unable to fetch Ticket Details")
    });
  }
  var filteredTicketTypes = ticketTypesResponse.filteredTicketTypes,
    ticketTypes = ticketTypesResponse.ticketTypes;
  var populatedTypes = ticketDetails.type.map(function (type) {
    return ticketTypes.find(function (ticketType) {
      return ticketType.id === type;
    });
  });
  var ticketWithPopulatedTypes = Object.assign({}, ticketDetails, {
    type: populatedTypes
  });
  var NewDetailsViewContent = function NewDetailsViewContent() {
    if (editMode) {
      return /*#__PURE__*/_react["default"].createElement(_TicketDetailsEditMode.TicketDetailsEditMode, {
        height: height,
        width: width,
        ticketDetails: ticketDetails,
        updateTicketDetails: handleUpdateTicket,
        ticketTypes: ticketTypes,
        filteredTicketTypes: filteredTicketTypes,
        setEditMode: setEditMode,
        isFullScreen: isFullScreen
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_TicketDetailsViewMode.TicketDetailsViewMode, {
      height: height,
      width: width,
      ticketDetails: ticketDetails,
      updateTicketDetails: handleUpdateTicket,
      ticketTypes: ticketTypes,
      setEditMode: setEditMode,
      createTicketComment: handleCreateComment,
      editTicketComment: handleEditTicketComment,
      deleteTicketComment: handleDeleteTicketComment,
      onAssigneeClick: handleAssigneeClick,
      onAssignToUser: handleAssignToUser,
      onClose: handleClose,
      refreshData: refreshTicketData,
      ticketWithPopulatedTypes: ticketWithPopulatedTypes,
      isFullScreen: isFullScreen
    });
  };
  if (isFullScreen) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("NewTicketDetailsScreen.title", "Ticket Details"),
      "data-testid": "NewTicketDetails"
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AppNavbar.AppNavbar, {
      title: translate("TicketDetailsScreen.navbar.title", "Ticket Details")
    }), NewDetailsViewContent()));
  }
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsWrapper, {
    "data-testid": "NewTicketDetails",
    isFullScreen: isFullScreen,
    width: width,
    height: height
  }, NewDetailsViewContent());
});